<cmps-tabset
    class="cmps-coaching-detail-pillar-two--tabset"
    [(selectedTabRefId)]="_selectedTabRefId"
    *ngIf="!state?.pending?.reload"
>
    <ng-container *ngIf="_userObs | async as user">
        <div
            class="cmps-coaching-detail-pillar-two--user-info"
            *ngIf="pillarOneCollapsible"
        >
            <cmps-user-info
                [hideImageAndSvgIcon]="true"
                [username]="user?.name"
                usernameDisplay="label"
            >
                <ng-template cmpsUserInfoLabels>
                    <div
                        cmpsUserInfoLabel
                        *ngIf="user?.superGroupName"
                    >
                        {{ _i18n._9552_SG_ | translate }}
                        {{ user?.superGroupName }}
                    </div>
                </ng-template>
            </cmps-user-info>
        </div>
    </ng-container>
    <cmps-tabset-label-wrapper
        class="cmps-coaching-detail-pillar-two--label-wrapper"
    >
        <ng-template
            cmpsTabLabel
            [tabRefId]="_TabRefId.COMMITMENTS"
            let-ctx
        >
            <button
                cmpsTabButton
                theme="c"
                [selected]="ctx.selected"
                (click)="ctx.select(_TabRefId.COMMITMENTS)"
            >
                <span cmpsTabButtonLabel>{{
                    _i18n._7453_COMMITMENTS | translate
                }}</span>
            </button>
        </ng-template>
        <ng-template
            cmpsTabLabel
            [tabRefId]="_TabRefId.OBSERVATIONS"
            let-ctx
        >
            <button
                cmpsTabButton
                theme="c"
                [selected]="ctx.selected"
                (click)="ctx.select(_TabRefId.OBSERVATIONS)"
            >
                <span cmpsTabButtonLabel>{{
                    _i18n._7377_OBSERVATIONS | translate
                }}</span>
            </button>
        </ng-template>
        <ng-template
            cmpsTabLabel
            [tabRefId]="_TabRefId.TRANSCRIPTS"
            let-ctx
        >
            <button
                cmpsTabButton
                theme="c"
                [selected]="ctx.selected"
                (click)="ctx.select(_TabRefId.TRANSCRIPTS)"
                *ngIf="state?.allowedActions?.viewTranscriptSummaryTab"
            >
                <span cmpsTabButtonLabel>{{
                    _i18n._9996_TRANSCRIPTS | translate
                }}</span>
            </button>
        </ng-template>
    </cmps-tabset-label-wrapper>
    <cmps-tabset-content-wrapper
        class="cmps-coaching-detail-pillar-two--content-wrapper"
    >
        <ng-template
            cmpsTabContent
            [tabRefId]="_TabRefId.COMMITMENTS"
        >
            <cmps-scrollbar>
                <cmps-accordion
                    class="cmps-coaching-detail-pillar-two--accordion cmps-coaching-detail-pillar-two--cmt"
                    [multi]="true"
                    *ngIf="!state?.pending?.reloadCommitments"
                >
                    <ng-container *ngFor="let c of state?.commitmentCategories">
                        <cmps-accordion-item
                            [isOpen]="c.isOpen"
                            (isOpenChange)="_onCategoryOpenChange(c, $event)"
                        >
                            <cmps-accordion-header>
                                <span
                                    >{{ c.label | translate }} ({{
                                        c.items?.length
                                    }})</span
                                >
                                <div
                                    class="cmps-coaching-detail-pillar-two--active-metric"
                                    *ngIf="
                                        c.containsMetricId &&
                                        state?.metricIdIsInMultiple
                                    "
                                ></div>
                            </cmps-accordion-header>
                            <cmps-accordion-content>
                                <ng-container *ngFor="let i of c.items">
                                    <cmps-coaching-activity-status-wrapper
                                        class="cmps-coaching-detail-pillar-two--item-margin"
                                        [label]="
                                            state?.commitmentStatuses[
                                                i.cmtIdentifier
                                            ]?.show
                                                ? (state?.commitmentStatuses[
                                                      i.cmtIdentifier
                                                  ]?.label | translate)
                                                : ''
                                        "
                                        [color]="
                                            state?.commitmentStatuses[
                                                i.cmtIdentifier
                                            ]?.show
                                                ? state?.commitmentStatuses[
                                                      i.cmtIdentifier
                                                  ]?.color
                                                : '#1e60d4'
                                        "
                                    >
                                        <cmps-coaching-focus-item
                                            [attr.data-commitments]="
                                                i.cmtIdentifier
                                            "
                                            class="cmps-coaching-focus-item--focused"
                                            [unfocusedLabel]="
                                                _i18n._9579_FOCUS_CONTAINER__UNFOCUSED_
                                                    | translate
                                            "
                                            [behaviourLabel]="
                                                _i18n._9525_B_ | translate
                                            "
                                            [behaviour]="i.behaviour"
                                            [subBehaviourLabel]="
                                                _i18n._9526_S_B_ | translate
                                            "
                                            [subBehaviour]="i.subBehaviour"
                                            [hasDetailAction]="
                                                i.behaviour != null
                                            "
                                            (detailAction)="
                                                _onCommitmentClick(i)
                                            "
                                            [hasEditAction]="i.hasEditAction"
                                            [editActionTooltip]="
                                                _i18n._9776_EDIT_COMMITMENT
                                                    | translate
                                            "
                                            (editAction)="
                                                _onEditCommitmentClick(i)
                                            "
                                            [hasAddAction]="i.hasAddAction"
                                            [addActionTooltip]="
                                                _i18n._9742_ADD_OBSERVATION
                                                    | translate
                                            "
                                            (addAction)="
                                                _onAddObservationClick(i)
                                            "
                                        >
                                        </cmps-coaching-focus-item>
                                        <cmps-coaching-commitment-badge-container>
                                            <cmps-coaching-commitment-badge
                                                [backgroundColor]="
                                                    i.statusBgColor
                                                "
                                                [textColor]="i.statusTextColor"
                                            >
                                                <cmps-icon
                                                    [svgIcon]="i.statusIcon"
                                                ></cmps-icon>
                                                <span>{{
                                                    i.statusLabel | translate
                                                }}</span>
                                            </cmps-coaching-commitment-badge>
                                            <cmps-coaching-commitment-badge
                                                backgroundColor="#d17300"
                                                textColor="#fff"
                                                *ngIf="i.containsMetricId"
                                            >
                                                <span>{{
                                                    _i18n._9822_SELECTED_METRIC
                                                        | translate
                                                }}</span>
                                            </cmps-coaching-commitment-badge>
                                        </cmps-coaching-commitment-badge-container>
                                        <cmps-coaching-focus-item-summary
                                            [opportunityLabel]="
                                                _i18n._9564_OPPORTUNITY_TO_DEMONSTRATE_
                                                    | translate
                                            "
                                            [opportunity]="
                                                i.opportunityToDemonstrate ==
                                                null
                                                    ? '-'
                                                    : (i.opportunityToDemonstrate
                                                      | cmpsPercent: '0.0-0')
                                            "
                                            [willingnessLabel]="
                                                _i18n._9565_WILLINGNESS_TO_TRY_
                                                    | translate
                                            "
                                            [willingness]="
                                                i.willingnessToTry == null
                                                    ? '-'
                                                    : (i.willingnessToTry
                                                      | cmpsPercent: '0.0-0')
                                            "
                                            [proficiencyLabel]="
                                                _i18n._9566_PROFICIENCY_
                                                    | translate
                                            "
                                            [proficiency]="
                                                i.proficiencyDelivered == null
                                                    ? '-'
                                                    : (i.proficiencyDelivered
                                                      | cmpsPercent: '0.0-0')
                                            "
                                        ></cmps-coaching-focus-item-summary>
                                        <cmps-coaching-commitment-goal-summary
                                            [metricLabel]="
                                                _i18n._9427_GOAL_METRIC
                                                    | translate
                                            "
                                            [percentRemainingLabel]="
                                                _i18n._767___TO_GOAL | translate
                                            "
                                            [daysToAchievementLabel]="
                                                _i18n._9434_DAYS_TO_ACHIEVEMENT
                                                    | translate
                                            "
                                        >
                                            <ng-container
                                                *ngFor="let r of i.goals"
                                            >
                                                <cmps-coaching-commitment-goal-summary-row
                                                    [metric]="r.metricShortName"
                                                    [percentRemaining]="
                                                        r.currentPctToGoal ==
                                                        null
                                                            ? '-'
                                                            : (r.currentPctToGoal
                                                              | cmpsPercent
                                                                  : '1.0-2')
                                                    "
                                                    [daysToAchievementIcon]="
                                                        r.daysToAchievementIcon
                                                    "
                                                    [daysToAchievementColor]="
                                                        r.daysToAchievementColor
                                                    "
                                                    [daysToAchievement]="
                                                        (r.daysToAchievementLabel
                                                            | translate) ||
                                                        r.daysToAchievement +
                                                            ' ' +
                                                            (_i18n._9570_DAYS
                                                                | translate)
                                                    "
                                                ></cmps-coaching-commitment-goal-summary-row>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="i.goals?.length === 0"
                                            >
                                                <div class="text-center">
                                                    {{
                                                        _i18n._842_N_A
                                                            | translate
                                                    }}
                                                </div>
                                            </ng-container>
                                        </cmps-coaching-commitment-goal-summary>
                                    </cmps-coaching-activity-status-wrapper>
                                </ng-container>
                            </cmps-accordion-content>
                        </cmps-accordion-item>
                    </ng-container>
                </cmps-accordion>
            </cmps-scrollbar>
        </ng-template>
        <ng-template
            cmpsTabContent
            [tabRefId]="_TabRefId.OBSERVATIONS"
        >
            <cmps-scrollbar>
                <cmps-accordion
                    class="cmps-coaching-detail-pillar-two--accordion cmps-coaching-detail-pillar-two--accordion--observations cmps-coaching-detail-pillar-two--obs"
                    [multi]="true"
                    *ngIf="!state?.pending?.reloadObservations"
                >
                    <ng-container
                        *ngFor="let c of state?.observationCategories"
                    >
                        <cmps-accordion-item
                            [isOpen]="c.isOpen"
                            (isOpenChange)="_onCategoryOpenChange(c, $event)"
                        >
                            <cmps-accordion-header
                                class="cmps-accordion-header--category"
                            >
                                <cmps-coaching-focus-item
                                    class="cmps-coaching-focus-item--border-radius cmps-coaching-detail-pillar-two--item-margin"
                                    [class.cmps-coaching-focus-item--focused]="
                                        c.behaviour || c.subBehaviour
                                    "
                                    unfocusedLabel="{{
                                        c.label | translate
                                    }} ({{
                                        c.published
                                            ? c.focusItems.publishedItems
                                                  .focusContainers.length
                                            : c.focusItems.draftItems
                                                  .focusContainers.length
                                    }})"
                                    [behaviourLabel]="
                                        _i18n._9525_B_ | translate
                                    "
                                    [behaviour]="c.behaviour"
                                    [subBehaviourLabel]="
                                        _i18n._9526_S_B_ | translate
                                    "
                                    [subBehaviour]="c.subBehaviour"
                                ></cmps-coaching-focus-item>
                            </cmps-accordion-header>
                            <cmps-accordion-content>
                                <ng-container
                                    *ngFor="let i of c?.focusItemsArr"
                                >
                                    <cmps-accordion-item
                                        [isOpen]="
                                            c.behaviour ? i.isOpen : c.isOpen
                                        "
                                    >
                                        <cmps-accordion-header
                                            *ngIf="c.behaviour"
                                        >
                                            <span
                                                >{{ i.label | translate }} ({{
                                                    i.focusContainers &&
                                                        i.focusContainers
                                                            .length
                                                }})</span
                                            >
                                        </cmps-accordion-header>
                                        <cmps-accordion-content
                                            class="cmps-accordion-content--category-item"
                                        >
                                            <ng-container
                                                *ngFor="
                                                    let f of i.focusContainers
                                                "
                                            >
                                                <cmps-coaching-observation-summary
                                                    [attr.data-observations]="
                                                        f.observationId
                                                    "
                                                    class="cmps-coaching-detail-pillar-two--item-margin"
                                                    [class.cmps-coaching-detail-pillar-two--item-bg]="
                                                        !state
                                                            ?.observationStatuses[
                                                            f.observationId
                                                        ]
                                                    "
                                                    [notesLabel]="
                                                        _i18n._9577_NOTES_
                                                            | translate
                                                    "
                                                    [notes]="
                                                        f.numNotes.toString()
                                                    "
                                                    [interactionsLabel]="
                                                        _i18n._9578_INTERACTIONS_EVALUATED_
                                                            | translate
                                                    "
                                                    [interactions]="
                                                        f.numInteractions.toString()
                                                    "
                                                    [dateLabel]="
                                                        _i18n._9783_DATE_
                                                            | translate
                                                    "
                                                    [date]="
                                                        f.date
                                                            | cmpsDate
                                                                : 'LLL-dd-yyyy'
                                                    "
                                                    [published]="f.published"
                                                    [active]="
                                                        state
                                                            ?.observationStatuses[
                                                            f.observationId
                                                        ]
                                                    "
                                                    (action)="
                                                        _onObservationClick(
                                                            i,
                                                            f
                                                        )
                                                    "
                                                    [opportunityLabel]="
                                                        _i18n._9564_OPPORTUNITY_TO_DEMONSTRATE_
                                                            | translate
                                                    "
                                                    [opportunity]="
                                                        f.opportunityToDemonstrate ==
                                                        null
                                                            ? '-'
                                                            : (f.opportunityToDemonstrate
                                                              | cmpsPercent
                                                                  : '0.0-0')
                                                    "
                                                    [willingnessLabel]="
                                                        _i18n._9565_WILLINGNESS_TO_TRY_
                                                            | translate
                                                    "
                                                    [willingness]="
                                                        f.willingnessToTry ==
                                                        null
                                                            ? '-'
                                                            : (f.willingnessToTry
                                                              | cmpsPercent
                                                                  : '0.0-0')
                                                    "
                                                    [proficiencyLabel]="
                                                        _i18n._9566_PROFICIENCY_
                                                            | translate
                                                    "
                                                    [proficiency]="
                                                        f.proficiencyDelivered ==
                                                        null
                                                            ? '-'
                                                            : (f.proficiencyDelivered
                                                              | cmpsPercent
                                                                  : '0.0-0')
                                                    "
                                                    [actionTooltip]="
                                                        (f.published
                                                            ? _i18n._9744_VIEW_OBSERVATION
                                                            : _i18n._9743_EDIT_OBSERVATION
                                                        ) | translate
                                                    "
                                                ></cmps-coaching-observation-summary>
                                            </ng-container>
                                        </cmps-accordion-content>
                                    </cmps-accordion-item>
                                </ng-container>
                            </cmps-accordion-content>
                        </cmps-accordion-item>
                    </ng-container>
                </cmps-accordion>
            </cmps-scrollbar>
        </ng-template>

        <ng-template
            cmpsTabContent
            [tabRefId]="_TabRefId.TRANSCRIPTS"
        >
            <cmps-coaching-detail-pillar-two-transcript-summary></cmps-coaching-detail-pillar-two-transcript-summary>
        </ng-template>
    </cmps-tabset-content-wrapper>
</cmps-tabset>
